<template>
  <div class="Recruitment">
    <ComTitlte titleEn="RECRUITING POSITION" titleZh="招聘岗位"></ComTitlte>
    <div class="jobList">
      <div
        :class="['jobItem', item.isShowAll ? '' : 'hideMore']"
        v-for="(item, index) in recruitmentList"
        :key="index"
      >
        <div class="jobTopBar">
          <div class="jobName">{{ item.job }}</div>
          <div class="publishTime">发布时间：{{ item.publishTime }}</div>
          <div class="btn_more" @click="OnOpenMore(index, item)">
            {{ item.isShowAll ? "收起" : "展开" }}
          </div>
        </div>
        <div class="itemBox box_info">
          <div class="b_title">
            <i class="item_icon icon_info"></i>
            <span>岗位介绍</span>
          </div>
          <div class="desc" v-html="item.info"></div>
        </div>
        <div class="itemBox box_require">
          <div class="b_title">
            <i class="item_icon icon_require"></i>
            <span>岗位要求</span>
          </div>
          <div class="desc" v-html="item.require"></div>
        </div>
        <div class="box_footer">
          <div class="b_item b_email">
            <i class="b_icon b_icon1"></i>
            <span>投递邮箱： {{ item.email }} </span>
          </div>
          <div class="b_item b_name">
            <i class="b_icon b_icon2"></i>
            <span>联系人： {{ item.name }} </span>
          </div>
          <div class="b_item b_phone">
            <i class="b_icon b_icon3"></i>
            <span>联系电话： {{ item.phone }} </span>
          </div>
          <div class="b_item b_address">
            <i class="b_icon b_icon4"></i>
            <span>单位地址： {{ item.address }} </span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="box_pagination">
      <el-pagination background layout="prev, pager, next" :total="1000">
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "Recruitment",
  data() {
    return {
      recruitmentList: [
        {
          id: 1,
          job: "研究员",
          publishTime: "2021年11月28日",
          info: `
          <p>（1）项目工作的研究设计：如方案撰写、问卷设计等必要工作；</p>
            <p>
              （2）项目质量监控：如对项目质量进行把控，样本调配、实地督导、项目培训等；
            </p>
            <p>
              （3）与委托方沟通：如按要求、时点提供相应材料、协调项目工作过程中的问题、及时处理突发状况等；
            </p>
            <p>
              （4）完成项目成果：如撰写数据分析报告、项目实施报告、校对报告、装订排版等；
            </p>
            <p>（5）部门交办的其他工作：如文稿校对、数据处理、资料收集等。</p>
            `,
          require: `
            <p>
              （1）全日制大学本科或以上学历，年龄要求35周岁以下，时间计算截止至公告报名截止日；
            </p>
            <p>
              （2）具有社会学（含社会学类）、人口学、统计学、经济学、经济统计学、管理学等相关专业学科背景（附上证明材料）。
            </p>
            <p>
              （3）熟练掌握计算机基本操作技能，精通WORD、EXCEL、SPSS等办公软件、数据处理软件操作；
            </p>
            <p>
              （4）热爱研究分析工作，对数字敏感，具有缜密的逻辑思维，擅长分析，注重细节;
            </p>
            <p>
              （5）需具备较强的数据分析能力和统计分析报告撰写能力，能独立拟写调查问卷、设计项目方案、撰写调查分析报告者优先考虑；
            </p>
            <p>（6）有过社会调研或统计工作经验的应聘者优先考虑。</p>
            `,
          email: "office@gztjssws.com",
          name: "陈小姐",
          phone: "83523942",
          address: "广州市越秀区文德路67号金德大厦9楼",
          isShowAll: false,
        },
        {
          id: 2,
          job: "业务拓展员",
          publishTime: "2021年11月28日",
          info: `
          <p>（1）负责事务所的对外宣传工作，拓展业务范围；</p>
            <p>
              （2）密切跟踪政府部门网站和各类招标平台，及时收集与事务所业务相关的招标信息；
            </p>
            <p>
              （3）负责协助拓展和建立与政府相关部门的沟通，维护与政府部门融洽的关系，保持长期稳定的业务合作。
            </p>
            <p>
              （4）跟进项目前期资料准备，协助开展相关调查；
            </p>
            <p>（5）其他协办事宜。</p>
            `,
          require: `
            <p>
              （1）全日制大学专科或以上学历，年龄要求35周岁以下，时间计算截止至公告报名截止日；
            </p>
            <p>
              （2）具有统计学、市场营销、社会学、管理学等相关学科背景（附上证明材料）；
            </p>
            <p>
              （3）对市场调查和统计工作具有一定的认知，为人乐观外向，具有很好的沟通表达能力和业务洽谈能力；
            </p>
            <p>
              （4）有过社会调研、统计工作经验或有一定的客户资源的应聘者优先考虑。
            </p>
            `,
          email: "office@gztjssws.com",
          name: "陈小姐",
          phone: "83523942",
          address: "广州市越秀区文德路67号金德大厦9楼",
          isShowAll: false,
        },
        {
          id: 3,
          job: "执行助理",
          publishTime: "2021年11月28日",
          info: `
          <p>（1）调查实施前期准备：如调查员选聘、调查培训组织、调查人员安排等；</p>
            <p>
              （2）调查执行过程：如电话调查、网络调查程序设计和电话访问系统维护、实地调查租车安排、调查点及调查路线确认、统计报表布置及催报和回收等；
            </p>
            <p>
              （3）调查实施后期：如调查数据审核、调查数据质量回访调查数据台账整理等；
            </p>
            <p>
              （4）项目质量监控：如调查质量控制及监督、调查资料整理归档、劳务费核定等；
            </p>
            <p>（5）部门交办的其他工作。</p>
            `,
          require: `
            <p>
              （1）全日制大学专科或以上学历，年龄要求35周岁以下，时间计算截止至公告报名截止日；
            </p>
            <p>
              （2）具有社会学（含社会学类）、统计学、财会等相关专业学科背景（附上证明材料）。
            </p>
            <p>
              （3）对调查问卷和统计报表有较强的理解能力，能开展调查培训；组织能力、统筹协调能力强，能独立完成执行工作；
            </p>
            <p>
              （4）熟练掌握计算机基本操作技能，精通WORD、EXCEL等办公软件，经培训能够熟练使用PAD或智能手机等电子设备开展调查；
            </p>
            <p>
              （5）有过社会调研或统计工作经验的应聘者优先考虑；
            </p>
            `,
          email: "office@gztjssws.com",
          name: "陈小姐",
          phone: "83523942",
          address: "广州市越秀区文德路67号金德大厦9楼",
          isShowAll: false,
        },
        {
          id: 4,
          job: "数据处理员",
          publishTime: "2021年11月28日",
          info: `
          <p>（1）负责调查问卷和统计报表的审核工作：如审核报表中的逻辑关系，根据现实情况发现数据异常情况；</p>
            <p>
              （2）负责调查问卷和统计报表的录入程序编写工作：为不同内容的调查问卷报表设计录入程序，能在程序中包括逻辑检验关系；
            </p>
            <p>
              （3）负责数据汇总工作：根据各项指定的数据来源，制定所需数据作表；
            </p>
            <p>
              （4）部门交办的其他工作。
            </p>
            `,
          require: `
            <p>
              （1）本科及以上学历，数学、统计学等相关专业优先；
            </p>
            <p>
              （2）熟悉Excel操作使用，有VBA编程经验、熟悉sql工具者优先考虑；
            </p>
            <p>
              （3）对数据敏感，热爱数据处理工作，具有良好的数据分析和逻辑思维能力。
            </p>
            `,
          email: "office@gztjssws.com",
          name: "陈小姐",
          phone: "83523942",
          address: "广州市越秀区文德路67号金德大厦9楼",
          isShowAll: false,
        },
      ],
    };
  },
  methods: {
    // 查看更多
    OnOpenMore(index) {
      this.recruitmentList[index].isShowAll =
        !this.recruitmentList[index].isShowAll;
    },
  },
  components: { ComTitlte },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.Recruitment {
  width: $themeMinWidth;
  margin: 0 auto;
  position: relative;
  .jobList {
    .jobItem {
      margin: 20px 0 0 0;
      padding: 20px 30px 70px;
      background-color: #ffffff;
      box-shadow: 2px 3px 7px 0px rgba(0, 0, 0, 0.19);
      border-radius: 10px;
      position: relative;
      transition: 0.4s;
      &.hideMore {
        padding: 20px 30px 20px;
        .itemBox .desc {
          display: block;
          height: 30px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
        .box_footer {
          opacity: 0;
          z-index: -1;
        }
      }
      .jobTopBar {
        display: flex;
        justify-content: space-between;
        height: 30px;
        .jobName {
          width: 680px;
          height: 30px;
          font-size: 20px;
          line-height: 30px;
          color: #333333;
        }
        .publishTime {
          width: 370px;
          height: 30px;
          font-size: 14px;
          line-height: 30px;
          color: #666666;
        }
        .btn_more {
          font-size: 16px;
          height: 30px;
          line-height: 30px;
          color: #406cdd;
          cursor: pointer;
        }
      }
      .itemBox {
        padding: 10px 0 0 0;
        .b_title {
          display: flex;
          align-items: center;
          .item_icon {
            display: block;
            width: 20px;
            height: 20px;
            margin: 0 6px 0 0;
            &.icon_info {
              background: url("../../assets/img/recruit/a_icon1.png") no-repeat;
              background-size: contain;
            }
            &.icon_require {
              background: url("../../assets/img/recruit/a_icon2.png") no-repeat;
              background-size: contain;
            }
          }
          span {
            font-size: 16px;
            line-height: 30px;
            color: #333333;
          }
        }
        .desc {
          padding: 0 0 0 26px;
          transition: 0.4s;
          /deep/ p {
            font-size: 16px;
            line-height: 30px;
            text-align: justify;
            color: #666666;
          }
        }
      }
      .box_footer {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 50px;
        line-height: 50px;
        box-sizing: border-box;
        padding: 0 60px;
        background-color: #ecf1ff;
        border-radius: 0px 0px 10px 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        transition: 0.2s;
        z-index: 6;
        .b_item {
          display: flex;
          align-items: center;
          .b_icon {
            display: inline-block;
            width: 20px;
            height: 20px;
            margin: 0 6px 0 0;
            &.b_icon1 {
              background: url("../../assets/img/recruit/a_icon3.png") no-repeat;
              background-size: contain;
            }
            &.b_icon2 {
              background: url("../../assets/img/recruit/a_icon4.png") no-repeat;
              background-size: contain;
            }
            &.b_icon3 {
              background: url("../../assets/img/recruit/a_icon5.png") no-repeat;
              background-size: contain;
            }
            &.b_icon4 {
              background: url("../../assets/img/recruit/a_icon6.png") no-repeat;
              background-size: contain;
            }
          }
          span {
            font-size: 14px;
            line-height: 28px;
            color: #333333;
          }
        }
      }
    }
  }
  .box_pagination {
    text-align: center;
    margin: 30px 0 0 0;
    /deep/ .el-pager .number.active {
      background-color: #406cdd;
    }
  }
}
</style>
